import ValidationType from '../ValidationType';
import { numberIsLessThan, numbersAreEqual } from "../../util";

class LessThanEqualValue extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      const current = fieldResponse.currentValue;
      const compare = validation.value;
      if (!numberIsLessThan(current, compare) && !numbersAreEqual(current, compare)) {
        let validation_value = validation.value;
        if (fieldResponse.fieldInstance.field.fieldType.defined_as == "FIELD_DURATION"){
          validation_value = validation.value + " minutes";
        }
        errors.push(this.createValidationError({
          fieldResponse: fieldResponse,
          key: 'ERROR_LESS_THAN_OR_EQUAL_TO_SPECIFIED_VALUE',
          values: { value: validation_value },
          message: `Value should be less than or equal to ${validation_value}`,
        }));
      }
    }
    return errors;
  }
}

export default LessThanEqualValue;
